import React, {useEffect, useState} from "react";
import * as BookPageHelpers from './helpers.js';
import * as Helpers from '../helpers.mjs';
import { useElasticData, useExtraData } from "./DataContext.js";
import BookCoverSize from './BookCoverSize.js';
import Cookies from "js-cookie";
import { currency } from "../helpers.mjs";

//TODO: Replace use of dangerouslySetInnerHTML with array.map() or array.filter().map();
const BookPageTabs = () => {
    
    let { productData, bindings, bookBands, product, themaCodes, ukslcCodes, bicCodes, productResources, distributorInfo, bookMatchRatings, keyStageInfo } = useElasticData();
    
    let { extraData, _source, getFormattedDate, isGuestUser, isLibraryUser, isSchoolsUser, isInternal, bookAwardsArray, internalKeywordsData } = useExtraData();
 
    const [tabs, setTabs] = useState([]);

    const bookbandsArray = _source.productcategorylinks ? _source.productcategorylinks.filter(pcl => bookBands[pcl]) : [];

    const includeBibText = (_source.bib_tag && _source.bib_tag !== "" && _source.bib_tag?.length > 300);

    const generateTabs = () => {
        let _tabs = []
    
        if(_source.annotation || includeBibText || _source.contents){
            _tabs.push("Annotation");
        }

        _tabs.push("Details");

        if(bookMatchRatings?.length > 0 || bookbandsArray?.length > 0 || _source.lexiles || _source.lexile_level || _source.book_level || _source.ar_interest_level || _source.quiz_number || _source.points || _source.quiz_date || _source.reading_recovery_level || _source.phonic_phase_level) {
            _tabs.push("Levelling information");
        }

        if(productResources?.length > 0){
            _tabs.push("Resources");
        }

        if(isInternal()){
            _tabs.push("Internal");
        }

        if(!isGuestUser){
            _tabs.push(`${extraData?.authname ? extraData?.authname : "My"} notes`);
        }

        if(isGuestUser || isSchoolsUser){
            _tabs[0] = "Our review";
        }

        if(_source.author_bio){
            _tabs.push("About the author");
        }

        return _tabs;
    }

    const authorDetails = () => {
        let details = [];

        if (_source.author_is_a_list === true) {
            details.push("A-list children's");
        }
        if (_source.author_is_b_list === true) {
            details.push("B-list children's");
        }
        if (_source.author_is_a_list_adult === true) {
            details.push("A-list adult");
        } 
        if (_source.author_is_b_list_adult === true) {
            details.push("B-list adult");
        }
        if (_source.author_is_scottish === true) {
            details.push("Scottish");
        }
        if (_source.author_is_welsh === true) {
            details.push("Welsh");
        }
        if (_source.author_is_bame === true) {
            details.push("BAME");
        }
        if (_source.author_is_irish === true) {
            details.push("Irish");
        }

        if (details.length) {
            return details.join(', ');
        } else {
            return false;
        }
    }

    useEffect(() => {
        setTabs(generateTabs());
        $('.tabContainer').height($('.tabContent.current').height() + 50);

        //moveBookSize();

    }, [productResources, productData]);

    const buildLinks = (codes, codesTextMap, queryJsonTemplate) => {
        let linksHtml = "";
        
        if(Array.isArray(codes) && codes.length > 0) {        
            codes.forEach((code, index) => {
                let codestring = code
                if (typeof code === 'object' && !Array.isArray(code) && code !== null) {
                    codestring = code.value;
                }

                let codeQuery = btoa(queryJsonTemplate(codestring));
                let codeText = codesTextMap[codestring]?.description ? codesTextMap[codestring].description : codesTextMap[codestring];
                let comma = index < codes.length - 1 ? "," : "";
             
                if(codeText){
                    linksHtml += `<p class="needMore"><a href="/search-results/${codeQuery}">${codestring}</a><span class="searchToolTip">${codeText}</span>${comma}</p>`;
                } else if(codestring){
                    linksHtml += `<p>${codestring}${comma}</p>`;
                }
            });

        } else if(!Array.isArray(codes) && typeof codes === "string"){
            let codeQuery = btoa(queryJsonTemplate(codes));
            let codeText = codesTextMap[codes];

            if(codeText){
                linksHtml += `<p class="needMore"><a href="/search-results/${codeQuery}">${codes}</a><span class="searchToolTip">${codeText}</span></p>`;
            } else if(codes) {
                linksHtml += `<p>${codes}</p>`;
            }
        } else if(!Array.isArray(codes) && typeof codes === "object"){
            let codeQuery = btoa(queryJsonTemplate(codes.value));
            let codeText = codesTextMap[codes.value];

            if(codeText){
                linksHtml += `<p class="needMore"><a href="/search-results/${codeQuery}">${codes.value}</a><span class="searchToolTip">${codeText}</span></p>`;
            } else if(codes.value) {
                linksHtml += `<p>${codes.value}</p>`;
            }
        } 

        if(linksHtml) {
            return `<div class="linksList">${linksHtml}</div>`;
        }
        return
    }

    const bicCodeJsonTemplate = (code) => {
        return `{"bicCodes":{"value":"${code}"}}`
    }

    const themaJsonTemplate = (code) => {
        return `{"thema":{"code":"${code}"}}`
    }

    const ukslcSubjectJsonTemplate = (code) => {
        return `{"ukslc":{"subject":{"value":"${code}"}}}`
    }

    const ukslcAgeJsonTemplate = (code) => {
        return `{"ukslc":{"age":{"value":"${code}"}}}`
    }

    const ukslcTreatmentJsonTemplate = (code) => {
        return `{"ukslc":{"treatment":{"value":"${code}"}}}`
    }

    const ukslcAudienceJsonTemplate = (code) => {
        return `{"ukslc":{"audience":{"value":"${code}"}}}`
    }

    const ukslcBootypeJsonTemplate = (code) => {
        return `{"ukslc":{"booktype":{"value":"${code}"}}}`
    }

    const ukslcBroadSubjectJsonTemplate = (code) => {
        return `{"ukslc":{"broad_subject":{"value":"${code}"}}}`
    }

    const ukslcGenreJsonTemplate = (code) => {
        return `{"ukslc":{"genre":{"value":"${code}"}}}`
    }

    const NotesPanel = ({tabIndex}) => {
        const name = `tab-${tabIndex}`;

        return(
            <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                <textarea id="myNotesInput" defaultValue={productData ? productData.bookNotes : ""} />
                <div className="row endAlign">
                    <span className="bookNotesLastEdited">{ productData.bookNotesLastEdited ? `Last edited: ${new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'medium' }).format(new Date(productData.bookNotesLastEdited))}` : "No history" }</span>
                    <button id="myNotesSave" type="button" className="button">Save changes</button>
                </div>
            </div>
        )
    }    

    const buildPanelContents = (panel) => {

        let _pHtml = "";
        let widthClass = {
            1 : "",
            2 : "half",
            3 : "third"
        }

        switch (true) {
            case typeof panel === "string":
                _pHtml = panel;
                break;
        
            case typeof panel === "object" && Array.isArray(panel):
                let columns = panel;
                
                columns.forEach(column => {
                    _pHtml += `<div class="${widthClass[columns.length]} column"><h4>${column.heading}</h4>`;
        
                    for (const label in column.rows) {
                        
                        _pHtml += `<div class="columns wrap"><div class="half column"><strong>${label}</strong></div><div class="half column">${column.rows[label]}</div></div>`; 

                    }
                    
                    _pHtml += "</div>";
                });
                

                break;
            default:
                break;
        }

        return _pHtml;
    }

    function switchPanel(e){
        let selectedTab = e.target;
        let selectedTabId = e.target.dataset.tab;

        let tabsSection = selectedTab.closest(".bookInformationSection");

        let productTabs = tabsSection.querySelectorAll(".productTab");
        productTabs.forEach(tab => {
            tab.classList.remove('current');
        });

        let productPanels = tabsSection.querySelectorAll(".tabContent");
        productPanels.forEach(panel => {
            panel.style = "";
            panel.classList.remove('current');
        });

        let selectedPanel = document.querySelector(`#${selectedTabId}`);
        selectedTab.classList.add("current");
        selectedPanel.style.opacity = "1";
        selectedPanel.classList.add("current");

        // document.cookie = "bookPageTab="+selectedTabId+"; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";

        Cookies.set("bookPageTab", selectedTabId, {sameSite: "Strict", path: "/", expires: 253372806925});

        $('.tabContainer').height($('.tabContent.current').height() + 50);

        //! Doesn't work, causes panel rto shrink to zero height
        //* look at public\assets\modules\bookpage\helpers.js line 154
        // $(selectedPanel).animate({
        //     opacity: 1,
        //     height: "toggle"
        // }, 1000);

    }

    let _html = [];

    let sel = Cookies.get("bookPageTab");
    if (!sel) {
        sel = "tab-1"
    }

    // Annotations
    const Tabs = () => {
        return(
            <ul className="productPageTabs">
                {tabs && tabs.map((t, i) => <li key={`productTab${i}`} className={`productTab ${"tab-"+(i+1) == sel ? "current" : ""}`} data-tab={`tab-${i + 1}`} onClick={(e) => {switchPanel(e)}}>{t}</li>)}
            </ul>
            
        );
    }

    const AnnotationsPanel = ({tabIndex}) => {
        const name = `tab-${tabIndex}`;

        // Check if review & BOTW text match?
        const review = _source.evaluation?.trim();
        var botwText = _source.botw_review_any?.replace(/<[^>]+>/g, '');
        var specialCharacters =
        {
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#039;': "'"
        };
        botwText = botwText?.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function(m) {return specialCharacters[m];});
        const reviewDoesNotMatchBOTW = (botwText != review);

        const newline = /\r\n|\r|\n/

        return(
            <div id={name} key={`tabindex${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                <div className="columns wrap">
                    <div className="noteSection">
                        <h4 className="titleText">Notes</h4>

                        {isSchoolsUser && productData.bwText != null && !!(productData.bwText) && <div className="textBlock">
                            <strong>Book of the week</strong>
                            <div dangerouslySetInnerHTML={{__html: productData.bwText}}></div>
                        </div>}

                        {isGuestUser && <><div className="loginRequired"><a className="login">Log in</a> to view our full review.</div><br /></>}
                        {isSchoolsUser && !isGuestUser && reviewDoesNotMatchBOTW && <div className="textBlock">
                            <strong>Our review</strong>
                            <p>{_source.evaluation ? _source.evaluation : "N/A"}</p>
                        </div>}

                        {(_source.annotation || includeBibText) && <div className="textBlock">
                            {isSchoolsUser && <strong>Summary</strong>}
                            {includeBibText && <div className="bibTag">
                                <p>{_source.bib_tag}</p>
                                {_source.annotation && <br/>}
                            </div>}
                            {_source.annotation && <p>{_source.annotation.split(newline).map((p, i, pp) => <>{p}{i < pp.length - 1 && <><br/></>}</>)}</p>}
                        </div>}

                        {isSchoolsUser && bookAwardsArray.length > 0 && <div className="textBlock">
                            <strong>Awards</strong>
                            <ul>
                                {bookAwardsArray.map(b => <li>{b}</li>)}
                            </ul>
                        </div>}

                        {isSchoolsUser && _source.advisory_note && <div className="textBlock">
                            <strong>Content advisory</strong>
                            <p>{_source.advisory_note}</p>
                        </div>}
                    </div>
                    {!!(_source.contents) && <div className="noteSection">
                        <div className="textBlock">
                            <strong>Contents</strong>
                            <p>{_source.contents.split(/\n/).map((p, i, pp) => <>{p}{i < pp.length - 1 && <><br /></>}</>)}</p>
                        </div>    
                    </div>}
                </div>
            </div>
        )
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const ResourcesPanel = ({tabIndex}) => {
        const name = `tab-${tabIndex}`;
    
        const _resources = productResources.length > 0 ? productResources.map((rs, i) => <div className="third column">
            {!isGuestUser && <>
                <a href={rs.link} className="contentItemImage" target="_blank"><img src={`/assets/img/resources/${rs.type}.jpg`} /></a>
                <a href={rs.link} target="_blank"><strong>{capitalizeFirstLetter(rs.type.replaceAll('_', ' '))}</strong></a>
            </>}
            {isGuestUser && <>
                <a className="contentItemImage" target="_blank"><img src={`/assets/img/resources/${rs.type}.jpg`} /></a>
                <a><strong>{capitalizeFirstLetter(rs.type.replaceAll('_', ' '))}</strong></a>
            </>}
            <p><strong>{rs.description}</strong></p>
        </div>) : [];
        
        return(
            <>
                <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                    <p>Click on the icons below to download your free resources.</p>
                    <div id="resourcesList" className="columns wrap contentItems">
                    {_resources}
                    </div>
                </div>
            </>
        )
    }

    const DetailsPanel = ({tabIndex}) => {
        const name = `tab-${tabIndex}`;
        // Details
        let _details = [];

        if(isGuestUser || isSchoolsUser){
            _details[0] = {
                "heading" : "",
                "rows" : {}
            };

            if(_source.category){
                _details[0].rows["Category"] = _source.category;
            }
            if(_source.peters_subject){
                _details[0].rows["Subject"] = _source.peters_subject;
            }

            if(extraData && !!(extraData.customerDewey)){
                _details[0].rows["Customer dewey"] = extraData.customerDewey
            }

            if(_source.language && _source.language?.length > 0){
                _details[0].rows[`Language${_source.language?.length > 1 ? "s" : ""}`] = _source.language?.map(l => l.title).join("/");
            }

            if(_source.dewey){
                _details[0].rows["Dewey"] = _source.dewey;
            }


            if(keyStageInfo.keyStage){
                _details[0].rows["Key stage"] = keyStageInfo.keyStage;
            }

            if(isGuestUser){
                _details[0].rows["Reading age"] = `<div class="loginRequired"><a class="login">Log in</a> to view reading age.</div>`;

            } else if(!isGuestUser && (_source.lower_reading_age || _source.upper_reading_age)){
                let readingAgeRange;
                
                if(_source.lower_reading_age && _source.upper_reading_age){
                    readingAgeRange = `${_source.lower_reading_age} - ${_source.upper_reading_age}`
                }
                if(_source.lower_reading_age && !_source.upper_reading_age){
                    readingAgeRange = `upto ${_source.upper_reading_age}`
                
                }
                if(!_source.lower_reading_age && _source.upper_reading_age){
                    readingAgeRange = `${_source.lower_reading_age} and above`
                }

                _details[0].rows["Reading age"] = readingAgeRange;
            } 

            if(isGuestUser){
                _details[0].rows["Interest Level"] = `<div class="loginRequired"><a class="login">Log in</a> to view interest age.</div>`;

            } else if(!isGuestUser && (_source.lower_interest_age || _source.upper_interest_age)){
                let interestAgeRange;
                
                if(_source.lower_interest_age && _source.upper_interest_age){
                    interestAgeRange = `${_source.lower_interest_age} - ${_source.upper_interest_age}`
                }
                if(_source.lower_interest_age && !_source.upper_interest_age){
                    interestAgeRange = `upto ${_source.upper_interest_age}`
                
                }
                if(!_source.lower_interest_age && _source.upper_interest_age){
                    interestAgeRange = `${_source.lower_interest_age} and above`
                }

                _details[0].rows["Interest Level"] = interestAgeRange;
            }

            if(_source.primary_illustrator_nat){
                _details[0].rows["Illustrator"] = `<a href='/search-results?searchTerm=${_source.primary_illustrator_nat}&searchType=ill'>${_source.primary_illustrator_nat}</a>`;
            }

            if(_source.illustrations){
                _details[0].rows["Illustrations"] = _source.illustrations;
            }

            if(_source.series_display){
                _details[0].rows["Series"] = `<a href='/search-results?searchTerm="${_source.series_display}"&searchType=series'>${_source.series_display}</a>`;
            }

            if(_source.volume){
                _details[0].rows["Series volume"] = _source.volume;
            }

            if(_source.publisher.title && _source.publisher.title != "UNKNOWN"){
                _details[0].rows["Publisher"] = `<a href='/search-results?searchTerm=${encodeURIComponent(_source.publisher.title)}&searchType=pub'>${_source.publisher.title}</a>`;
            }

            if (_source.imprint && _source.imprint.title != "" && _source.imprint.title != _source.publisher.title && _source.imprint.title != "UNKNOWN") {
                _details[0].rows["Imprint"] = `<a href='/search-results?searchTerm=${encodeURIComponent(_source.imprint.title)}&searchType=pub'>${_source.imprint.title}</a>`;
            }

            if(_source.publish_date){
                _details[0].rows["Pub. date"] = BookPageHelpers.getFormattedDate(_source.publish_date);
            }

            if(_source.pub_history){
                _details[0].rows["Pub. history"] = _source.pub_history;
            }

            if(_source.edition){
                _details[0].rows["Edition"] = _source.edition;
            }

            if(_source.id || _source.isbn){
                let isbn = _source.id ? _source.id : _source.isbn;
                _details[0].rows["ISBN"] = isbn;
            }

            if(_source.bic_code){
                _details[0].rows["BIC code"] = `<a href='/search-results?bic=${_source.bic_code.value}'>${_source.bic_code.value}</a>`;
            }

            _details[1] = {
                "heading" : "",
                "rows" : {}
            };

            if(_source.binding){
                _details[1].rows["Binding"] = bindings[_source.binding];
            }

            if(_source.pages){
                _details[1].rows["Pages"] = _source.pages;
            }

            if(_source.width){
                _details[1].rows["Width"] = `${_source.width}mm`;
            }

            if(_source.height){
                _details[1].rows["Height"] = `${_source.height}mm`;
            }

            if(_source.weight > 0){
                _details[1].rows["Weight"] = `${_source.weight}g`;
            }

            _details[1].rows["Index"] = `${_source.index  ? "Yes" : "No"}`;
            _details[1].rows["Contents page"] = `${_source.contents_page ? "Yes" : "No"}`;
            _details[1].rows["Glossary"] = `${_source.glossary ? "Yes" : "No"}`;
            _details[1].rows["CE Mark"] = `${_source.ce_mark ? "Yes" : "No"}`;


            if(parseFloat(productData.peVatSplit) && parseFloat(productData.peVatCode)){
                let totalVat = parseFloat(productData.peVatSplit) * parseFloat(productData.peVatCode);
                _details[1].rows["VAT-able amount"] = `${BookPageHelpers.getFormattedPrice(totalVat)}`;
            }

            if(authorDetails()){
                _details[1].rows["Author attributes"] = authorDetails();
            }
            
            if(_source.width && _source.height){
                _details[1].rows["Product dimensions"] = `<div id="productDimensions"></div>`;
            }
      
        }

        if(isLibraryUser()){
            // Physical characteristics column
            _details[0] = {
                "heading" : "Physical characteristics",
                "rows" : {}
            };

            if(_source.binding){
                _details[0].rows["Binding"] = bindings[_source.binding];
            }

            if(_source.width){
                _details[0].rows["Width"] = `${_source.width}mm`;
            }

            if(_source.height){
                _details[0].rows["Height"] = `${_source.height}mm`;
            }

            if(_source.weight > 0){
                _details[0].rows["Weight"] = `${_source.weight}g`;
            }

            if(_source.illustrations){
                _details[0].rows["Illustrations"] = _source.illustrations;
            }

            _details[0].rows["Index"] = `${_source.index ? "Yes" : "No"}`;
            _details[0].rows["Contents page"] = `${_source.contents_page ? "Yes" : "No"}`;
            _details[0].rows["Glossary"] = `${_source.glossary ? "Yes" : "No"}`;
            _details[0].rows["CE Mark"] = `${_source.ce_mark ? "Yes" : "No"}`;

            if(authorDetails()){
                _details[0].rows["Author attributes"] = authorDetails();
            }

            if(_source.format_issues){
                _details[0].rows["Format issues"] = _source.format_issues.join(' | ')
            }
            // Appeal column
            _details[1] = {
                "heading" : "Appeal",
                "rows" : {

                }
            };

            if(keyStageInfo.keyStage){
                const keyStageValuesString = keyStageInfo.keyStage.split(' / ')?.map(e => e.replace("Key Stage ",'')).sort((a, b) => a > b).join(", ");

                _details[1].rows["Key stage"] = keyStageValuesString;
            }

            if(keyStageInfo.yearGroup){
                const yearGroupValuesString = keyStageInfo.yearGroup.split(' / ')?.map(e => e.replace("Year ",'')).sort((a, b) => a > b).join(", ");
                _details[1].rows["Year groups"] = yearGroupValuesString;
            }

            _details[1].rows["Hi Lo?"] = `${_source.hi_lo ? "Yes" : "No"}`;
            _details[1].rows["Leisure NF"] = `${_source.leisure_nf ? "Yes" : "No"}`;
            _details[1].rows["Curriculum NF"] = `${_source.curriculum_nf ? "Yes" : "No"}`;

            if(_source.best_year_group?.title != ""){
                _details[1].rows["Best year group"] = _source.best_year_group.title;
            }
            // Bibliographic column
            _details[2] = {
                "heading" : "Bibliographic",
                "rows" : {}
            }

            if(_source.thema_codes){
                const themaLinksHtml = buildLinks(_source.thema_codes, themaCodes, themaJsonTemplate);
                if(themaLinksHtml) {
                    _details[2].rows["Thema"] = buildLinks(_source.thema_codes, themaCodes, themaJsonTemplate);
                }
            }

            if(_source.bic_code){
                const biLinksHtml = buildLinks(_source.bic_code, bicCodes, bicCodeJsonTemplate);
                if(biLinksHtml) {
                    _details[2].rows["BIC code"] = buildLinks(_source.bic_code, bicCodes, bicCodeJsonTemplate);
                }
            }

            if(_source.ukslc_subject){
                const subjectLinksHtml = buildLinks(_source.ukslc_subject, ukslcCodes, ukslcSubjectJsonTemplate);
                if(subjectLinksHtml) {
                    _details[2].rows["UKSLC subject"] = buildLinks(_source.ukslc_subject, ukslcCodes, ukslcSubjectJsonTemplate);
                }
            }

            if(_source.ukslc_age){
                const ageLinksHtml = buildLinks(_source.ukslc_age, ukslcCodes, ukslcAgeJsonTemplate);
                if(ageLinksHtml) {
                    _details[2].rows["UKSLC age"] = buildLinks(_source.ukslc_age, ukslcCodes, ukslcAgeJsonTemplate);
                }
            }

            if(_source.ukslc_treatment){
                const treatmentLinksHtml = buildLinks(_source.ukslc_treatment, ukslcCodes, ukslcTreatmentJsonTemplate);
                if(treatmentLinksHtml) {
                    _details[2].rows["UKSLC treatment"] = buildLinks(_source.ukslc_treatment, ukslcCodes, ukslcTreatmentJsonTemplate);
                }
            }

            if(_source.ukslc_audience){
                const audienceLinksHtml = buildLinks(_source.ukslc_audience, ukslcCodes, ukslcAudienceJsonTemplate);
                if(audienceLinksHtml) {
                    _details[2].rows["UKSLC audience"] = buildLinks(_source.ukslc_audience, ukslcCodes, ukslcAudienceJsonTemplate);
                }
            }

            if(_source.ukslc_booktype){
                const booktypeLinksHtml = buildLinks(_source.ukslc_booktype, ukslcCodes, ukslcBootypeJsonTemplate);
                if(booktypeLinksHtml) {
                    _details[2].rows["UKSLC booktype"] = buildLinks(_source.ukslc_booktype, ukslcCodes, ukslcBootypeJsonTemplate);
                }
            }

            if(_source.ukslc_broad_subject){
                const broadLinksHtml = buildLinks(_source.ukslc_broad_subject, ukslcCodes, ukslcBroadSubjectJsonTemplate);
                if(broadLinksHtml) {
                    _details[2].rows["UKSLC broad subject"] = buildLinks(_source.ukslc_broad_subject, ukslcCodes, ukslcBroadSubjectJsonTemplate);
                }
            }

            if(_source.ukslc_genre){
                const genreLinksHtml = buildLinks(_source.ukslc_genre, ukslcCodes, ukslcGenreJsonTemplate);
                if(genreLinksHtml) {
                    _details[2].rows["UKSLC genre"] = buildLinks(_source.ukslc_genre, ukslcCodes, ukslcGenreJsonTemplate);
                }
            }

            if (_source.library_of_congress_class) {
                _details[2].rows["Library of Congress class"] = _source.library_of_congress_class;
            }

            if (_source.library_of_congress_headings) {
                // regex here to add spaces to commas missing them
                _details[2].rows["Library of Congress headings"] = _source.library_of_congress_headings.join(", ");
            }

            if(_source.pub_history){
                _details[2].rows["Publish history"] = _source.pub_history;
            }
        }

        const isObjectEmpty = (objectName) => {
            return JSON.stringify(objectName) === "{}";
        };
        // Check for empty columns and strip from array
        _details.forEach((sec, i) => {
            if(isObjectEmpty(sec.rows)) {
                _details.splice(i, 1);
            }
        })
        // Set column size on number of groups in array
        let _columnsClass = "";

        if(_details.length == 2) {
            _columnsClass = "half"
        } else if(_details.length == 3) {
            _columnsClass = "third"
        } else if(_details.length == 4) {
            _columnsClass = "quarter"
        }

        const detailsHeadings = _details.map(x => x.heading);
        const detailsRows = Object.values(_details.map(x => x.rows));

        let detailsHtml = "";

        detailsRows.forEach((row, i) => {
            let rowLabels = Object.keys(row);
            let rowValues = Object.values(row);
            let detailsRowsHtml = "";
            
            rowLabels.forEach((label, j) => {
                detailsRowsHtml += `<div class="half column"><strong>${label}</strong></div><div class="half column">${rowValues[j]}</div>`;
            });

            detailsHtml += `<div class="${_columnsClass} column">${detailsHeadings[i] ? `<h4>${detailsHeadings[i]}</h4>` : ``}<div class="columns wrap">${detailsRowsHtml}</div></div>`;

        });

        return(
            <>
                <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                    <div className="columns wrap" dangerouslySetInnerHTML={{__html: detailsHtml}} /> 
                    {(isSchoolsUser && _source.width  && _source.height) && <BookCoverSize />}
                </div>
            </>
        )
    }

    const bookBandList = (pclinks) => {
        let bblHtml = "";

        if(pclinks){
            pclinks.filter(c => bookBands[c]).forEach((pc, i) => {
                bblHtml += `<li><span class="swatch cat${pc}" title="${bookBands[pc]}">${bookBands[pc]}</span></li>`;
            });
        }

        if (bblHtml == "") {
            return "";
        }

        return `<ul class="bookBanding">${bblHtml}</ul>`;
    };

    const bookbands = bookBandList(_source.productcategorylinks);
    
    const LevellingPanel = ({tabIndex}) => {
        const name = `tab-${tabIndex}`;

        // Levelling information
        let _levelling = [];
        
        if (bookMatchRatings?.length > 0) {
            _levelling.push({
                "heading": "Oxford BookMatch<sup>&trade;</sup>",
                "rows": {
                    "Level": `${bookMatchRatings.bmLowLevel} - ${bookMatchRatings.bmHighLevel}`
                }
            })
        }
        
        if (_source.book_level || _source.ar_interest_level || _source.quiz_number || _source.points) {
            let rows = {};
            
            if (_source.book_level) {
                rows["Level"] = _source.book_level;
            }

            if (_source.ar_interest_level) {
                rows["Interest"] = _source.ar_interest_level;
            }

            if (_source.quiz_number) {
                rows["Quiz Number"] = _source.quiz_number;
            }

            if (_source.points) {
                rows["Points"] = parseFloat(_source.points).toFixed(1);
            }

            _levelling.push({
                "heading" : "Renaissance AR<sup>&trade;</sup>",
                "rows" : rows
            });
        }

        // const bookbands = _source.productcategorylinks !== null ? _source.productcategorylinks.filter(c => bookBands[c]).map(c => <li><span className={`swatch cat${c}`} title={bookBands[c]}>{bookBands[c]}</span></li>) : [];

        if (bookbandsArray.length > 0) {
            _levelling.push({
                "heading" : "Book Band(s)",
                "rows" : {
                    "" : bookbands
                }
            });
        }

        // if (productData.peCatchupCategory || _source.prcatchuplevel) {
        //     _levelling.push({
        //         "heading" : "Catch Up<sup>&reg;</sup>",
        //         "rows": {
        //             "Category": productData.peCatchupCategory,
        //             "Level": _source.prcatchuplevel,
        //         }
        //     });
        // }

        const levellingHeadings = _levelling.map(x => x.heading);
        const levellingRows = Object.values(_levelling.map(x => x.rows));
        let levellingHtml = "";

        levellingRows.forEach((rows, i) => {
            let rowLabels = Object.keys(rows);
            let rowValues = Object.values(rows);
            let levellingRowsHtml = "";
            
            rowLabels.forEach((label, j) => {
                levellingRowsHtml += `${label ? `<div class="half column"><strong>${label}</strong></div>` : ``}<div class="half column">${rowValues[j]}</div>`;
            });

            levellingHtml += `<div class="half column"><h4>${levellingHeadings[i]}</h4><div class="columns wrap">${levellingRowsHtml}</div></div>`;

        });

        return(
            <>
                <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                    {isGuestUser && <div className="loginRequired"><a className="login">Log in</a> to view levelling information.</div>}
                    {!isGuestUser && <div className="columns wrap" dangerouslySetInnerHTML={{__html: levellingHtml}} />}
                </div>
            </>
        )
    }

    const distributorTable = () => {

        let tableHead = "<thead><tr><th>Distributor</th><th>Qty</th><th>Disc</th><th>Firm?</th></tr></thead>"
        let tableRows = "";

        if(distributorInfo.length){
            distributorInfo.forEach((di, i) =>{
                tableRows += `<tr><td>${di.spName}</td><td>${di.dbdQtyHeld}</td><td>${di.dbdDiscount}</td><td>${di.dbdFirmSale === "1" ? "Y" : "N"}</td></tr>`;
            });
        }
    

        return `<table class="distributorTable">${tableHead}<tbody>${tableRows}</tbody></table>`;

    }    

    const InternalPanel = ({tabIndex}) => {
        const name = `tab-${tabIndex}`;

        // Internal
        let _internal = [];
        
        _internal[0] = {
            "heading" : "Internal info",
            "rows" : {
                "ID" : product,
                "Enhanced" : _source.enhanced ? "Yes" : "No",
                "Release date" : (_source.release_date === null || _source.release_date == "0001-01-01T00:00:00Z") ? "Unknown" : getFormattedDate(_source.release_date, { year: 'numeric', month: 'numeric', day: 'numeric' }),
                "Pre-pub date" : _source.pre_pub_assessment_date === null ? "N/A" : getFormattedDate(_source.pre_pub_assessment_date, { year: 'numeric', month: 'numeric', day: 'numeric' }),
                "BIN" : _source.bin_location,
                "On order" : _source.peters_has_stock ? "Yes" : "No",
                "Stock" : _source.stock_level_display,
                "Stock control level" : _source.control_figure,
                "Reserved" : _source.reserved_level,
                "Last intake" : _source.date_last_intake && _source.date_last_intake != "0000-00-00" ? getFormattedDate(_source.date_last_intake, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
                "Report code" : _source.report_code === null ? "" : _source.report_code,
                "Distributor" : `${_source.distributor.title} (${_source.distributor.value})`,
                "Discount code" : _source.discount_code,
                "Expected discount" : _source.expected_discount,
                "Cost price" : `${currency(productData?.costPrice)} (Source: "${productData?.costPriceSource}")`,
                "GP £" : productData?.gp,
                "GP %" : productData?.gpp,
                "Embargo date" : _source.embargo_date && _source.embargo_date != "0000-00-00" ? getFormattedDate(_source.embargo_date, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
                "Record created" : _source.record_created && _source.record_created != "0000-00-00" ? getFormattedDate(_source.record_created, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
                "BDS/Nielsen import" : _source.bds_import_time &&_source.bds_import_time != "0000-00-00" ? getFormattedDate(_source.bds_import_time, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
                "Updated" : (_source.updated_at && _source.updated_at != "0000-00-00" && _source.updated_at != _source.record_created) ? getFormattedDate(_source.updated_at, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
                // "BDS data source": productData.peSource,
                "Internal keyword": _source.internal_keywords && internalKeywordsData[_source.internal_keywords],
                "Librarian notes": _source.librarian_notes
            }
        };

        // const DistributorTable = _source.productcategorylinks !== null ? _source.productcategorylinks.filter(c => bookBands[c]).map(c => <li><span className={`swatch cat${c}`} title={bookBands[c]}>{bookBands[c]}</span></li>) : [];
        
        _internal[1] = {
            "heading" : "Distirbutor info",
            "rows" : {
                "" : distributorTable()
            }
        };

        const internalHeadings = _internal.map(x => x.heading);
        const internalRows = Object.values(_internal.map(x => x.rows));
        let internalHtml = "";

        internalRows.forEach((rows, i) => {
            let rowLabels = Object.keys(rows);
            let rowValues = Object.values(rows);
            let internalRowsHtml = "";
            
            rowLabels.forEach((label, j) => {
                if(rowValues[j] && rowValues[j] != "") {
                    internalRowsHtml += `${label ? `<div class="half column"><strong>${label}</strong></div><div class="half column">${rowValues[j]}</div>` : `${rowValues[j]}`}`;
                }
            });
            if(i == 0){
                internalHtml += `<div class="half column"><h4>${internalHeadings[i]}</h4><div class="columns wrap">${internalRowsHtml}</div></div>`;
            } else{
                internalHtml += `<div class="half column">${internalRowsHtml}</div>`;
            }

        });

        return(
            <>
                <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                    <div className="columns wrap" dangerouslySetInnerHTML={{__html: internalHtml}} />
                </div>
            </>
        )
    }
    
    const AuthorBioPanel = ({tabIndex}) => {
        const name = `tab-${tabIndex}`;

        let authorBioHtml = "";
        authorBioHtml += `<div class="noteSection"><h4 class="titleText">Author biography</h4><div className="textBlock">${_source.author_bio}</div></div>`;

        return(
            <div id={name} key={`tabindex${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                <div className="columns wrap" dangerouslySetInnerHTML={{__html: authorBioHtml}} />
            </div>
        )
    }
    
    const tabsArray = _html.length > 0 ? _html.map((section, index) => <li className={`productTab${index === 0 ? " current" : ""}`} data-tab={`tab-${index + 1}`} onClick={(e) => {switchPanel(e)}}>{section.tab}</li>) : [];

    const panelsArray = _html.length > 0 ? _html.map((section, index) => 
        <div id={`tab-${index + 1}`} className={`tabContent${index === 0 ? " current" : ""}`}><div className="columns wrap" dangerouslySetInnerHTML={{__html: buildPanelContents(section.panel)}} /></div>) : [];

    const getPanel = (tab, index) => {
        switch (tab) {
            case "Our review":
            case "Annotation":
                return <AnnotationsPanel tabIndex={index} />;
            case "Details":
                return <DetailsPanel tabIndex={index} />;
            case "Resources":
                return <ResourcesPanel tabIndex={index} />;
            case "Levelling information":
                return <LevellingPanel tabIndex={index} />;
            case "Internal":
                return <InternalPanel tabIndex={index} />;
            case "About the author":
                return <AuthorBioPanel tabIndex={index} />;
            default:
                return <NotesPanel tabIndex={index} />;
        }
    }

    return (
        <div className="bookInformationSection">
            <Tabs />
            <div className="tabContainer">
                {tabs && tabs.map((t, i) => getPanel(t, i + 1))}
            </div>
        </div>
    );
}

export default BookPageTabs;